import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import queryString from 'query-string';
import { authenticationService } from '.';

export function useAuth() {
  const { search } = useLocation();

  useEffect(() => {
    const queryParams = queryString.parse(search);
    if (queryParams && queryParams.isAdmin !== undefined) {
      const isAdmin = queryParams.isAdmin === 'true';
      authenticationService.setAdmin(isAdmin);
    } else {
      const isAdmin = false;
      authenticationService.setAdmin(isAdmin);
    }
  }, [search]);
}